import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { translations, DEFAULT_LANG } from "./translations";

const LANG_KEY = "vhrp_lang";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(DEFAULT_LANG);
  const [chosen, setChosen] = useState(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(LANG_KEY);
    if (saved && translations[saved]) {
      setLangState(saved);
      setChosen(true);
    }
    setReady(true);
  }, []);

  const setLang = useCallback(async (l) => {
    setLangState(l);
    setChosen(true);
    localStorage.setItem(LANG_KEY, l);
  }, []);

  const t = useCallback(
    (key) => translations[lang]?.[key] ?? translations.en[key] ?? key,
    [lang]
  );

  const value = useMemo(
    () => ({ lang, ready, chosen, t, setLang }),
    [lang, ready, chosen, t, setLang]
  );

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used inside I18nProvider");
  return ctx;
}

export { LANGUAGES, BENEFIT_KEYS, TIER_KEYS } from "./translations";
